import React, { createContext, useContext } from "react";

export interface CardRegistration {
  id: string;
  modelPath: string;
  element: HTMLElement;
  width: number;
  height: number;
}

export interface CanvasContextType {
  registerCard: (registration: CardRegistration) => void;
  unregisterCard: (id: string) => void;
  syncViewports: () => void;
  triggerSync: () => void; // Set flag to sync on next frame
}

export const CanvasContext = createContext<CanvasContextType | null>(null);

export const useCanvas = () => {
  const context = useContext(CanvasContext);
  if (!context) {
    throw new Error("useCanvas must be used within a CanvasProvider");
  }
  return context;
};
